import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { FurnishingsType } from '../types';

export class Snowplow2StatsAdapterFurnishings implements StatsAdapterInterface {
  /**
   * Furnished key => furnishing value
   */
  public mapping: { [key: string]: FurnishingsType } = {
    yes: 'furnished',
    no: 'unfurnished',
    partly: 'part_furnished',
    1: 'furnished',
    2: 'unfurnished',
    3: 'part_furnished',
  };

  /**
   *
   * @param furnished
   */
  constructor(protected furnished: string) {}

  /**
   * @inheritDoc
   */
  public getData(): FurnishingsType {
    // Returns the mapped value or falls back to null (WEB-2185)
    return this.mapping[this.furnished.toLowerCase()] || null;
  }
}
